module.exports = __webpack_public_path__ + "static/media/march2025-4.ab430435.webp";